
import { Component, OnInit, ViewChild } from '@angular/core';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Sort, MatSortModule, MatSort } from '@angular/material/sort'
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { BasemodelService } from '../basemodel.service';

@Component({
  selector: 'app-home-cctv',
  templateUrl: './home-cctv.component.html',
  styleUrls: ['./home-cctv.component.scss']
})
export class HomeCctvComponent implements OnInit {
  searchkey: string = '';
  public searchTerm: string = '';
  campusdata: any = [];
  selctedType: any;
  selected_value: any;
  backarrow: boolean = false;
  show: boolean = true;
  cityData: any;
  id: any;
  history: { value: string, id: any, campusName: any }[] = [];
  showsecond: boolean = false;
  filter: any;
  currentActiveData: any = 'connected';
  displayedColumns: string[] = ['stateName', 'cityName', 'campusName', 'totalCamerasInstalled', 'totalConnected', 'totalNotConnected', 'totalVideoStreaming', 'totalVideoNotStreaming',];
  dataSource = new MatTableDataSource<any>;
  campusName: any;
  constructor(public campuscctvserviceservice: CampuscctvserviceService, private http: HttpClient, private spinner: NgxSpinnerService, private liveAnnouncer: LiveAnnouncer,private base:BasemodelService) { }
  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit(): void {
    this.campusdetails();
    this.navigateBackward();
    this.searchTerm = '';
    this.history
  }
  campusdetails() {
    this.selected_value = "Campus"
    this.spinner.show();
    this.campuscctvserviceservice.getHomeData().subscribe(
      {
        next: (httpResponse: any) => {
          this.campusdata = httpResponse;
          console.log('campusdata', this.campusdata);
          this.spinner.hide();
          // this.history=[];
        },
        error: (err) => {
          console.log('Error', err);
          this.spinner.hide();
        },
        complete: () => {
          console.log('completed!');
        }
      }
    );
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    })
  }

  //========= dropdown list ==========//

  onOptionsSelected(e: any) {
    this.selected_value = e.target.value;
    this.show = true;
    this.showsecond = false;
    if (this.selected_value === "Campus") {
      this.spinner.show();
      this.http.get<any>((this.base.getcctv() + '/ses/cctv/status')).subscribe(Response => {
        if (Response) {
          this.searchTerm = '';
          this.campuscctvserviceservice.search.subscribe((val: any) => {
            this.searchkey = val;
          })
          this.campusdata = Response;
          console.log(this.campusdata);
          this.spinner.hide()
          this.history = [];
          this.backarrow = false;
          this.search({ event: { target: { value: '' } } })
        }
      });

    } else if (this.selected_value === "State") {
      this.spinner.show();
      this.http.get<any>((this.base.getcctv() + '/ses/cctv/overallCities')).subscribe(Response => {
        if (Response) {
          this.searchTerm = '';
          this.campuscctvserviceservice.search.subscribe((val: any) => {
            this.searchkey = val;
          })
          this.cityData = Response;
          console.log(this.cityData);
          this.spinner.hide();
          this.history = [];
          this.backarrow = false;
          this.search({ event: { target: { value: '' } } })
        }
      });
      this.spinner.show();
      this.http.get<any>((this.base.getcctv() + '/ses/cctv/overallStates')).subscribe(Response => {
        if (Response) {
          this.searchTerm = '';
          this.campuscctvserviceservice.search.subscribe((val: any) => {
            this.searchkey = val;
          })
          this.campusdata = Response;
          console.log(this.campusdata);
          this.spinner.hide();
          this.history = [];
          this.backarrow = false;
          this.search({ event: { target: { value: '' } } })
        }
      });


    } else if (this.selected_value === "City") {
      this.spinner.show();
      this.http.get<any>((this.base.getcctv() + '/ses/cctv/overallCities')).subscribe(Response => {
        if (Response) {
          this.searchTerm = '';
          this.campuscctvserviceservice.search.subscribe((val: any) => {
            this.searchkey = val;
          })
          this.campusdata = Response;
          console.log(this.campusdata);
          this.spinner.hide();
          this.history = [];
          this.backarrow = false;
          this.search({ event: { target: { value: '' } } })
        }
      });

    } else {
      console.log("no record found");
    }
  }

  //============= navigate Right click ==============//

  save(data: any) {
    this.show = false;
    this.backarrow = true;
    if (this.selected_value === "Campus") {
      this.id = data.campus_id ? data?.campus_id : data.campusId
      this.campusName = data.campusName

      this.searchTerm = '';
      this.search({ event: { target: { value: '' } } })

    } else if (this.selected_value === "State") {
      if (this.cityData) {
        this.id = data.stateId,
          this.campusName = data.stateName
        this.searchTerm = '';
        this.search({ event: { target: { value: '' } } })

      }
    } else if (this.selected_value === "City") {
      this.id = data.cityId
      this.campusName = data.cityName
      this.searchTerm = '';
      this.search({ event: { target: { value: '' } } })
    }
    this.history.push({ value: this.selected_value, id: this.id, campusName: this.campusName })
    console.log("history", this.history);

  }

  changeType(type: any) {
    console.log(type);
    this.selected_value = "City"
    this.save(type)
  }

  change(type: any) {
    console.log(type);
    this.selected_value = "Campus"
    this.save(type)
  }

  //================ Input Searchtext details ==============//

  search(event: any) {
    // this.searchTerm = (event.target as HTMLInputElement).value;
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
    // localStorage.setItem("searchText", event.target.value)
    // localStorage.getItem("searchText");
  }

  //===================== filter sorting data ===================//

  actionclick(element: any) {
    this.show = false;
    this.showsecond = false;
    this.id = element.campusId
  }
  action1click(element: any) {
    this.show = false;
    this.showsecond = false;
    this.id = element.campusId
  }
  action2click(element: any) {
    this.show = false;
    this.showsecond = false;
    this.id = element.campusId
  }
  action3click(element: any) {
    this.show = false;
    this.showsecond = false;
    this.id = element.campusId
  }

  connected() {
    this.spinner.show();
    this.currentActiveData = 'connected';
    this.showsecond = true;
    this.backarrow = false;
    this.campuscctvserviceservice.getconnceted().subscribe(res => {
      this.filter = res;
      this.spinner.hide();
      this.dataSource = new MatTableDataSource(this.filter)
      this.dataSource.sort = this.sort;
      this.history = []
    })
  }

  notconnected() {
    this.spinner.show();
    this.currentActiveData = 'not connected'
    this.showsecond = true;
    this.backarrow = false;
    this.campuscctvserviceservice.getnotconnceted().subscribe(res => {
      this.filter = res;
      this.spinner.hide();
      this.dataSource = new MatTableDataSource(this.filter)
      this.dataSource.sort = this.sort;
    })
  }

  streaming() {
    this.spinner.show();
    this.currentActiveData = 'streaming'
    this.showsecond = true;
    this.backarrow = false;
    this.campuscctvserviceservice.getstreaming().subscribe(res => {
      this.filter = res;
      this.spinner.hide();
      this.dataSource = new MatTableDataSource(this.filter)
      this.dataSource.sort = this.sort;
    })
  }

  notstreaming() {
    this.spinner.show();
    this.currentActiveData = 'notstreaming'
    this.showsecond = true;
    this.backarrow = false;
    this.campuscctvserviceservice.getnotstreaming().subscribe(res => {
      if (res === null) {
        this.filter = [];
        this.spinner.hide();
        this.dataSource = new MatTableDataSource(this.filter)
        this.dataSource.sort = this.sort;
      } else {
        this.filter = res;

      }

    })
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this.liveAnnouncer.announce('Sorting cleared');
    }
  }

  //======================== Navigate to Back Arrow Button ========================//

  navigateBackward() {
    console.log("hai", this.history)
    const currentIndex = this.history.findIndex(item => item.value === this.selected_value && item.id === this.id);
    console.log("hello", currentIndex, this.selected_value);
    if (currentIndex > 0) {
      const prevItem = this.history[currentIndex - 1];
      this.selected_value = prevItem?.value;
      this.id = prevItem?.id;
      this.campusName = prevItem?.campusName
      this.searchTerm = '';
      this.search({ event: { target: { value: '' } } })
      this.history.pop()

    } else {
      this.show = true;
      this.backarrow = false;
      this.history = [];
      this.searchTerm = '';
      this.search({ event: { target: { value: '' } } })

    }
  }


  onChangehistory(breadcrumb: any) {
    console.log('breadcrumb',breadcrumb);
    // this.show = false;
   

  }


}


